import FloorSwitcher from './FloorSwitcher';

export default FloorSwitcher;
